import styled from "@emotion/styled";
import { withConfig } from "src/withConfig";
import { Link } from "../../router/NewLink";
import { ChevronIcon } from "src/ui/assets/icons/arrow/ChevronIcon";

export const OutrightEventLink = withConfig(theme => styled(Link, { label: 'OutrightEventLink' })`
    background-color: ${theme.star.eventRow6PackColors.bgColor};
    color: ${theme.star.heroWidget.txtColor};
    border: 1px solid ${theme.star.heroWidget.borderColor};
    display: flex;
    flex-flow: column nowrap;
    font-size: ${theme.star.fontSize.small};
    gap: 8px;
    justify-content: center;
    line-height: 1;
    min-height: 48px;
    overflow: hidden;
    padding: 12px;
    position: relative;
    text-decoration: none;
    width: 100%;
`);

export const ChevronRightIcon = withConfig(theme => styled(ChevronIcon, { label: 'ChevronRightIcon' })`
    color: ${theme.star.heroWidget.txtColorSecondary};
    margin-top: -8px;
    position: absolute;
    right: 8px;
    top: 50%;
    width: 16px;
`);

export const StatusAndDateWrapper = withConfig(theme => styled('div', { label: 'StatusAndDateWrapper' })`
    font-size: ${theme.star.fontSize.xSmall};
`);